<template>
  <div class="tooltip">
    <Tooltip
      v-if="isResponse === false"
      :placement="placement"
      :content="content"
      :theme="theme"
      max-width="300"
    >
      <slot
        slot="content"
        name="content"
      />
      <Icon type="ios-help-circle" v-if="showIcon"/>
      <div v-else><slot name="text"/></div>
    </Tooltip>

    <Icon type="ios-help-circle" v-else @click="response"/>
  </div>
</template>

<script>
export default {
  props: {
    theme: {
      type: String,
      default: 'dark',
    },
    isResponse: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: '',
    },
    placement: {
      default: 'right',
      type: String,
    },
    width: {
      type: [String, Number],
      default: 400
    },
    /**展现形式-图标 */
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    response() {
      this.$emit('clickIcon', true)
    },
  },
}
</script>

<style scoped>
.tooltip {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/common/BaseTooltip/index.vue?601c510b